import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

function AdminLayout() {
  const { canAccessPage } = useAuth();

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <nav className="admin-nav">
          {canAccessPage('users') && (
            <NavLink to="/admin/users">User Management</NavLink>
          )}
          {canAccessPage('admin') && (
            <>
              <NavLink to="/admin/system-actions">System Actions</NavLink>
              <NavLink to="/admin/product-backfill">Product Backfill</NavLink>
              <NavLink to="/admin/transactions-reconciliation">Transactions &amp; Reconciliation</NavLink>
            </>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/print-jobs">Print Jobs</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/marketing-analytics">Marketing Analytics</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/lookbook">Lookbook</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/collection-creatives">Collection Creatives</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/facebook-ads">Facebook Ads</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/review-examples">Review Examples</NavLink>
          )}
          {canAccessPage('fabricSpecs') && (
            <NavLink to="/admin/fabric-specs">Fabric Specs</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/product-details">Product Details AI</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/product-video">Product Video</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/shopify-audit">Shopify Audit</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/shopify-theme">Shopify Theme</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/new-lookbook">Lookbook V2</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/v9-ops">V9 Ops</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/v9-orders">V9 Orders</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/v9-action-queue">V9 Action Queue</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/seo-engine">SEO Opportunity Engine</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/social-studio">Social Studio</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/blog">Blog Automation</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/channel-management">Channel Management</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/discounts">Discounts</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/discount-calendar">Discount Calendar</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/repeat-customer">Repeat Customer Discount</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/free-gift">Free Gift Collection</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/cod-pincode-risk">COD Pincode Risk</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/meta-audiences">Meta Audiences</NavLink>
          )}
          {canAccessPage('admin') && (
            <NavLink to="/admin/vendor-bills">Vendor Bills Automation</NavLink>
          )}
        </nav>
      </aside>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
